<!-- materialDev -->
<template>
  <div class="materialDev">
    <div class="bgBox section1 ">
      <div class="s1_innerBox typeArea">
        <div class="opctBox">
          <div class="p1">赛迈特专注打造新材料创新平台</div>
          <div class="line"></div>
        </div>
      </div>
    </div>
    <div class="bgBox section2 " id="材料研制与生产">
      <div class="s2_innerBox typeArea">
        <div class="bodyBox">
          <div class="top">
            <div class="box1">
              <div class="topTitle leftTop">
                <div class="p1">
                  <span>材料</span>研制与生产
                </div>
                <div class="p2"></div>
                <div class="p3">MATERIAL RESEARCH PRODUCTION</div>
                <div class="p4">
                  赛迈特已在增强悬浮力，提高设备熔炼温度，延长坩埚寿命，扩大设备规格，提高生产效率，改善合金均匀化，实现数字化、智能化操作等方面取得重大进步。可实现的技术包括：半连续浇铸、底铸、吸铸、离心铸造、挤压铸造、连续拉锭等，可与气雾化制粉，定向凝固、区熔提纯、快淬急冷等相结合。
                </div>
                <div class="p5">
                  公司依托悬浮冶金技术对外提供合金材料熔炼服务，迄今为止已为上千个单位熔炼数千炉次，客户群体均为国内外著名高等院校、顶级科研院所和高科技技术企业，熔炼出来的材料几乎都是通过其他材料制备手段无法获得或很难获得的金属和合金。
                </div>
                <div class="p5">
                  目前公司熔炼车间有10台冷坩埚真空感应悬浮熔炼设备，具备50g-50kg（按钢液密度计算）规格范围的合金材料熔炼能力，其中包含一台锭径110mm的冷坩埚真空感应拉锭设备。
                </div>
              </div>
            </div>
            <div class="box2">
              <div class="imgBox">
                <img src="../../static/images/materialDev/材料简介.jpg" alt="">
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bgBox section3 ">
      <div class="s3_innerBox typeArea">
        <div class="bodyBox">
          <div class="item">
            <div class="p1">1000+</div>
            <div class="p2">客户量</div>
          </div>
          <div class="item">
            <div class="p1">3000+</div>
            <div class="p2">熔炼炉次</div>
          </div>
          <div class="item">
            <div class="p1">8000kg+</div>
            <div class="p2">累计熔炼材料量</div>
          </div>
        </div>
      </div>
    </div>
    <div class="bgBox section4 " id="材料产品">
      <div class="s4_innerBox typeArea">
        <div class="topTitle centerTop">
          <div class="p1">
            <span>材料</span>产品
          </div>
          <div class="p2"></div>
          <div class="p3">MATERIAL  PRODUCT</div>
          <div class="p4">
            利用高端熔炼设备领域的技术领先优势，赛迈特提供量身定做的高端材料制备生产服务，各种高纯度靶材、难熔金属及合金、活泼金属及合金、贵金属及合金、高熵合金、各种合金棒材等，熔炼的材料都是用其它材料制备手段无法获得或很难获得的技术难度极高的材料。 包括生产企业的按需定制，长期合作形式，以及科研院所科研课题项目合作。</div>
        </div>
        <div class="bodyBox">
          <div class="p1" :class="active==1?'active':''" @click="section4func(1)">高纯金属</div>
          <div class="p1" :class="active==2?'active':''" @click="section4func(2)">高熵合金</div>
          <div class="p1" :class="active==3?'active':''" @click="section4func(3)">稀土金属及合金</div>
          <div class="p1" :class="active==4?'active':''" @click="section4func(4)">活泼金属及合金</div>
          <div class="p1" :class="active==5?'active':''" @click="section4func(5)">难熔金属及合金</div>
          <div class="p1" :class="active==6?'active':''" @click="section4func(6)">贵金属及合金</div>
          <div class="p1" :class="active==7?'active':''" @click="section4func(7)">功能材料</div>
          <div class="p1" :class="active==8?'active':''" @click="section4func(8)">溅射靶材</div>
        </div>
        <div class="items" v-for="(item,index) in listArr[active]" :key="'items'+index">
          <div class="p1">
            {{ item.name}}
          </div>
          <div class="p2" v-for="item in item.label" :key="item">
            {{item}}
          </div>
          <div class="imgBox">
            <div class="imgItem"
              :class="getNum(item.start,item2)==14?'twoWidth':getNum(item.start,item2)==53?'bigWidth':''"
              v-for="(item2,index) in item.imgList" :key="index">
              <img :src="'../../static/images/materialDev/'+ getNum(item.start,item2)+'.jpg'" alt="">
              <div class="nameBox">{{item.imgName[index]}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bgBox section5" id="客户案例">
      <div class="s5_innerBox typeArea">
        <div class="topTitle centerTop">
          <div class="p1">
            <span>客户</span>案例
          </div>
          <div class="p2"></div>
          <div class="p3">OUR CUSTOMER</div>
          <div class="pBox">
            设备得到国内外顶尖科研机构和企业客户的认可
          </div>
        </div>
        <div class="textBox">
          <div class="p">
            中国工程物理研究院、中国核动力研究设计院、中国科学院金属研究所、中国科学院合肥物质科学研究所、中国科学院宁波材料技术与工程研究所、中国科学院长春应用化学研究所、中国科学院力学研究所、北京有色金属研究总院、广州有色金属研究院、湖南稀土金属材料研究院、中国船舶重工集团第七二研究所、中国机械总院集团沈阳铸造研究所、昆明贵金属研究院等院所; </div>
          <div class="p">清华大学、北京大学、哈尔滨工业大学、北京航空航天大学、北京科技大学、北京工业大学、上海大学、上海理工大学、上海交通大学、南京工业大学、南京理工大学、南京航空航天大学、西安交通大学、西北工业大学、厦门大学、福州大学、渤海大学、郑州大学、中南大学、中北大学、南方科技大学 、哈尔滨工业大学深圳科技创新研究院、华南理工大学、重庆大学、长安大学、华中科技大学、太原理工大学、河北科技大学、大连理工大学、合肥工业大学、浙江大学、衢州学院等高校;</div>
          <div class="p">
            华为技术有限公司、昆明富尔诺林科技发展有限公司、瑞声光电科技(常州)有限公司、东莞宜安科技股份有限公司、中国核工业总公司第四零四厂、湖南顶立科技有限公司、攀钢集团有限公司、福建省长汀金龙稀土有限公司、中国东方航空股份有限公司、株洲硬质合金集团有限公司、北京合纵科技股份有限公司、广西瀚航稀土科技有限公司、沈阳东创机械装备有限公司、深圳市福摩索金属制品有限公司、西安耐百特电力储能科技股份有限公司、先导薄膜材料(广东)有限公司、山东通裕集团有限公司、湖南莱茵网络科技有限公司、厚普清洁能源(集团)股份有限公司等高科技企业 ;</div>
          <div class="p">以及TOSOH SMD,INC.的美国公司和日本公司，韩国的INCO Korea等国外公司，还有香港理工香港大学、台湾的国立清华大学和泰汶股份、光洋应用材料等港台的高校和企业。</div>
        </div>
      </div>
    </div>
    <div class="bgBox section7">
      <div class="s7_innerBox typeArea">
        <div class="itemBox">
          <div class="item">
            <img src="../../static/images/index/清华.jpg" alt="">
          </div>
          <div class="item">
            <img src="../../static/images/index/南工.jpg" alt="">
          </div>
          <div class="item">
            <img src="../../static/images/index/北科.jpg" alt="">
          </div>
          <div class="item">
            <img src="../../static/images/index/有研.jpg" alt="">
          </div>
          <div class="item">
            <img src="../../static/images/index/稀土.jpg" alt="">
          </div>
          <div class="item">
            <img src="../../static/images/index/计量.jpg" alt="">
          </div>
          <div class="item">
            <img src="../../static/images/index/铸造.jpg" alt="">
          </div>
          <div class="item">
            <img src="../../static/images/index/核动力.jpg" alt="">
          </div>
          <div class="item">
            <img src="../../static/images/index/工程.jpg" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'materialDev',
    components: {},
    data() {
      return {
        active: 1,
        listArr: {
          1: [{
            name: '高纯(5N)金属及合金',
            label: [
              "金属Co、Ti-Al、Ti-Ag、Ti-V-Fe-All、 CoFe-B、Ta-Fe-Co-B、V-Fe-Al等，均为TOSOH SMD. INC.(美国)熔炼"
            ],
            start: 38,
            imgList: 8,
            imgName: ['Co', 'Ti-50Al', 'Ti-Al', 'Ti-Al', 'TiVFeAl', 'Co-Fe-20B', 'Co-Fe-30B', 'V-Fe-7Al']
          }],
          2: [{
              name: '高熵合金材料',
              label: [
                "W、Ta、Mo、Nb、Hf、V、Zr、Ti、Al组合系高熵合金：WMoNbZr、WNbZrTi、WTaMoHf、WTaMoNb、WTaMoNbHf、WTaMoNbTi、WTaMoNbV、WTaMoNbZr、WTaNbZr、WTaNbZrTi、TaNbZrTi、TaNbVZrTi、TaNbVTi、TaHfZrTi、TaMoNbTiNi、TaMoNbV、NbHfVZrTi、NbVTiAl、NbVZrTi、MoCrTiSiAl、MoNbVTiAl等",
                "Co、Cr、Fe、Ni、Mn组合系高熵合金"
              ],
              start: 27,
              imgList: 4,
              imgName: ['WTaMoNbV', 'TaNbHfZrTi', 'TaMoVZrTi', 'CrFeCoNi']
            },
            {
              name: '中间合金和金属间化合物',
              label: ["Cr-Nb、Ni-Ta、Ti-Si、TiAl、Ti-AI-Cr-Nb、Ti-AI-Nb、Ni-AI、Mo-Si、b-Si等金属间化合物"],
              start: 36,
              imgList: 2,
              imgName: ['Ni40Mo（前左）、Ni50W前右）、Fe40Mo（后左）、Nb50W（后中）、Ti30V（后右）', 'TiAL、Ni3AI和Nb5Si3']
            }
          ],
          3: [{
            name: '稀土金属合金',
            label: [
              "La系单质稀土、Al-La、Al-Sc、Ce-Gd、Ni-Eu、Sm-Co、Sm-Fe、Tb-Dy-Fe、Nd-Fe-B、Gd-Si-Ge、Ce-Ag-Ti、Ce-Cu-AI-Co、La-Si等"
            ],
            start: 0,
            imgList: 4,
            imgName: ['Sc', 'Al-10Sc', 'Al-30Sc', 'Ce的吸铸棒']
          }],
          4: [{
            name: '活泼金属及合金',
            label: [
              "Ti、Ti-AI-V、Ti-AI、Ti-Si、Ti-Sn、Ti-V、Ti-Mo、Ti-Mo-Nb-Ta-V-W-Zr、Ti-Ta- Zr、Zr-Cu、Zr-AL Zr-Cu-AI-Y、Zr-Cu-AI-Fe、Zr-Co、Zr-Mg、Zr-Fe、Zr-Ta、V、V-Ta、V-(TiCr)等"
            ],
            start: 4,
            imgList: 9,
            imgName: ['Ti（10kg）', 'Zr（15kg）', 'Zr-Ti', 'Ti、Ti-Al和Ti-Si', 'Zr-Ta', 'HfZrTa5.4Ti', 'Ti-Al-4V',
              'Ti-614V和Ti-AlNb5Cr', 'Ti-Al'
            ]
          }],
          5: [{
            name: '难熔金属及合金',
            label: [
              "纯Al、W-Re系、W-Mo系、W-Nb系、W-Ta系(W-Ta-Cr-V-Ti、W-Ta-Fe-Ni、W-Ta-Hf、W-Mo-Nb-(NbB)等)、Ta-Ti系、Ta-Zr系、Ta-Nb系、Mo-Re系等"
            ],
            start: 13,
            imgList: 14,
            imgName: ['V(9kg) 、Nb(8kg)、Mo(5kg) 、Ta(3kg)、 W(2kg) 、Re(1.5kg)', 'W', 'Re', 'V', 'V-Ta', 'Nb-Zr',
              'Nb和Nb-20Ti', 'Mo和T i -5〜40Mo', 'Ta 和 Ta-5 〜40Ti ', 'Ta-45Zr10Nb', 'Ti-29Nb13Ta5Zr',
              '38Ta-NbHfTiAI (4kg/锭)', 'Co-33Cr-14W', 'W-20. 6Mo39. 9Nb'
            ]
          }, {
            name: 'Fe、Co、Ni基高温合金',
            label: [
              "Ni-Cr、Ni-Cr-W-Mo-AI-Ti(GH3044) 、Ni-AI-W、Co-Cr-W-Ni-Fe-Mnl(GH605)、Co-ClNi-W-Fe-Mn-Si、Co-Ni-W-Cr-AI-Ti-Ta、Fe-Cr、Fe-Al、Fe-Cr-AL、Fe-Ni-Cr-W-Mo(GH 1016)、W-Mo-Fe-Ni等合金"
            ],
            start: 35,
            imgList: 1,
            imgName: ['GH3044、GH1016和GH605']
          }, {
            name: '碳化物、氧化物、金属与碳化物,金属与氧化物',
            label: [
              "W+WC、TiC+B4C、ZrO2、UO2、ZrO2+(Zr、Fe)、AI2O3等",
            ],
            start: 50,
            imgList: 2,
            imgName: ['ZrO2', 'W+WC']
          }],
          6: [{
            name: '贵金属及合金',
            label: ["Ir、Rh、Au、Pd、Ir-Rh、Pt-Ag、Ag 、Ag-60A1、Ag-20Mg、Ti50Ag、Ti-Ag-Ce等"],
            start: 31,
            imgList: 4,
            imgName: ['Ir', 'Ir-Rh', 'Rh', 'Pt']
          }],
          7: [{
            name: '功能材料、半导体材料',
            label: [
              "超导合金：Nb-Ti (NbTi)、Nb-Sn ( NbSn)等",
              "稀土超磁致伸缩合金(GMM): TbDyFe",
              "储氢材料合金：V基、Fe基",
              "形状记忆合金：Ni-Ti、Ni-Ti( NiTi)等",
              "半导体及其合金：Si、Si-Al、Ge、Fe-Ge等",
            ],
            start: 46,
            imgList: 4,
            imgName: ['Nb-Ti 和Ni-Ti', 'TbDyFe', 'Zr基', 'Ce基']
          }],
          8: [{
            name: '溅射靶材',
            label: [
              "Fe-Cr-Al、Ni-Cr、Nb、Mo、Ti-Si、Ti-Al-Si、Mo10Nb、Zr、Zr-Y、Cr、Si、Ti、Ti-Al、Ti-Si、Ti-Al-Si、Ti-Ni、Ti-Ag、Ti-V等",
            ],
            start: 52,
            imgList: 1,
            imgName: []
          }]
        },
      }
    },
    computed: {},
    watch: {},
    created() {
      this.init()
    },
    mounted() {
      if(this.$store.state.pageId){
        this.$el.querySelector(this.$store.state.pageId).scrollIntoView({
          behavior:'smooth',
          block: "start"
        })
      }else{
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      }
      this.$store.commit('savePageId','')
    },
    methods: {
      init() {

      },
      section4func(data) {
        this.active = data
      },
      getNum(data1, data2) {
        return data1 + data2
      }
    },
  }

</script>

<style lang='less' scoped>
  .materialDev {
    width: 100%;
    min-width: 1200px;

    .section1 {
      width: 100%;
      height: 600px;
      background: url('../../static/images/materialDev/材料banner.jpg') no-repeat;
      background-position: center;

      .s1_innerBox {
        padding-top: 234px;
        text-align: left;

        .opctBox {
          width: 1245px;
          height: 230px;
          // opacity: 0.4;
          background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.1) 2%, rgba(0, 0, 0, 0.4) 20%, rgba(0, 0, 0, 0.4) 80%, rgba(255, 255, 255, 0.1) 98%, rgba(255, 255, 255, 0) 100%);

          .p1 {
            font-size: 48px;
            line-height: 48px;
            padding-top: 50px;
            color: #fefefe;
          }

          .line {
            width: 200px;
            height: 8px;
            margin-top: 85px;
            background-color: #c30000;
          }
        }

      }
    }

    .section2 {
      width: 100%;
      height: 850px;

      .s2_innerBox {
        height: 100%;
        padding-top: 261px;

        .bodyBox {
          width: 1190px;
          height: 588px;
          padding: 0 0 20px 35px;
          background-color: transparent;
          border: solid 2px #c30000;
          z-index: 99;
          position: relative;

          .top {
            display: flex;
            height: 460px;

            .box1 {
              flex: 1;

              .topTitle {
                .p1 {
                  margin-top: 35px;
                }

                .p3 {
                  margin-bottom: 50px;
                }

                .p4,
                .p5 {
                  font-size: 16px;
                  line-height: 28px;
                  color: #545454;
                  text-indent: 2em;
                  padding-right: 10px;
                  font-weight: 400;
                }
              }
            }

            .box2 {
              width: 569px;
              height: 355px;
              position: relative;

              .imgBox {
                width: 622px;
                height: 408px;
                background-color: #ffffff;
                box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.35);
                position: absolute;
                top: -53px;
                right: -53px;
                display: flex;
                justify-content: center;
                align-items: center;
              }

            }
          }


        }
      }
    }

    .section3 {
      width: 100%;
      height: 259px;
      background-color: #fbfbfb;
      margin-top: -50px;

      .s3_innerBox {
        height: 100%;

        // padding-top: 261px;
        .bodyBox {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: space-between;
          padding-left: 40px;

          .item {
            width: 250px;
            height: 100%;
            padding-top: 120px;

            .p1 {
              font-size: 60px;
              line-height: 60px;
              font-weight: 700;
              color: #c30000;
              text-align: left;
            }

            .p2 {
              font-size: 16px;
              line-height: 16px;
              font-weight: 400;
              color: #545454;
              margin-top: 25px;
              text-align: left;
            }
          }
        }

      }
    }

    .section4 {
      width: 100%;

      //   height: 906px;
      .s4_innerBox {
        height: 100%;

        .topTitle {
          .p1 {
            margin-top: 120px;
          }

          .p4 {
            font-size: 16px;
            line-height: 28px;
            color: #545454;
            font-weight: 400;
            margin-top: 49px;
            text-align: left;
          }
        }

        .bodyBox {
          margin-top: 85px;
          width: 100%;
          height: 192px;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-around;

          .p1 {
            width: 180px;
            height: 50px;
            line-height: 48px;
            border: solid 1px #c30000;
            ;
            font-size: 20px;
            font-weight: 400;
            color: #555555;
            margin: 0 40px;
            cursor: pointer;
          }

          .p1.active {
            background-color: #c30000;
            border: none;
            color: #ffffff;
            line-height: 50px;
          }
        }

        .items {
          margin-top: 50px;
          text-align: left;

          .p1 {
            font-size: 18px;
            line-height: 18px;
            font-weight: 400;
            color: #c30000;
            margin-bottom: 14px;
          }

          .p2 {
            font-size: 16px;
            line-height: 28px;
            font-weight: 400;
            color: #545454;
          }

          .imgBox {
            display: flex;
            flex-direction: row;
            margin-top: 18px;
            flex-wrap: wrap;

            .imgItem {
              // height: 214px;
              width: 232px;
              position: relative;
              margin-right: 8px;
              margin-bottom: 25px;

              img {
                width: 100%;
                height: 178px;
              }

              .nameBox {
                // height: 36px;
                line-height: 36px;
                width: 100%;
                text-align: center;
                font-size: 16px;
                font-weight: 400;
                color: #545454;
              }
            }

            .twoWidth {
              width: 464px;
            }

            .bigWidth {
              width: 475px;
              height: 308px;

              img {
                height: 308px;
              }
            }
          }
        }
      }
    }

    .section5 {
      width: 100%;
      padding-bottom: 40px;

      .s5_innerBox {
        position: relative;
        height: 100%;

        .topTitle {
          .p1 {
            margin-top: 140px;
          }
        }

        .pBox {
          background-color: #c30000;
          font-size: 20px;
          color: #ffffff;
          line-height: 44px;
          padding: 0 18px;
          width: fit-content;
          margin: 40px 0;
        }

        .textBox {
          text-align: left;

          .p {
            font-size: 16px;
            line-height: 28px;
            font-weight: 400;
            color: #545454;
          }
        }
      }
    }

    .section7 {
      height: 660px;
      width: 100%;
      background-color: #fbfbfb;
      margin-bottom: 69px;

      .s7_innerBox {
        position: relative;
        height: 100%;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        .itemBox {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          height: 620px;
        }

        .item {
          width: 395px;
          height: 200px;
          background-color: #ffffff;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            // width: 312px;
            height: auto;
          }
        }


      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/materialDev.vue